var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademixTextLogoMathematicsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 47.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.36,13.68c.98,0,1.91.24,2.79.71v3.07c-.53-.64-1-1.08-1.42-1.32-.41-.25-.89-.37-1.45-.37-.87,0-1.59.3-2.16.91s-.86,1.37-.86,2.29.28,1.71.83,2.31c.56.6,1.27.9,2.14.9.55,0,1.04-.12,1.47-.36.41-.23.89-.68,1.45-1.35v3.05c-.94.49-1.87.73-2.81.73-1.54,0-2.84-.5-3.88-1.5s-1.56-2.25-1.56-3.74.53-2.75,1.58-3.77,2.35-1.56,3.88-1.56ZM51.86,13.96h2.32v9.99h-2.32v-1.05c-.95.89-1.97,1.33-3.07,1.33-1.38,0-2.52-.5-3.42-1.5-.9-1.02-1.34-2.29-1.34-3.81s.45-2.74,1.34-3.74,2.02-1.5,3.36-1.5c1.16,0,2.2.48,3.13,1.44v-1.16ZM52,18.97c0-.94-.26-1.71-.79-2.32-.53-.59-1.21-.89-2.05-.89-.79,0-1.46.3-1.99.9-.53.61-.79,1.36-.79,2.26,0,.96.26,1.74.77,2.34.53.61,1.19.91,1.99.91.85,0,1.54-.29,2.07-.88.53-.61.79-1.38.79-2.32ZM64.38,6.62h2.32v17.32h-2.32v-1.05c-.91.89-1.94,1.33-3.09,1.33-1.37,0-2.5-.5-3.4-1.5-.9-1.02-1.34-2.29-1.34-3.81s.45-2.73,1.34-3.73,2.01-1.51,3.35-1.51c1.17,0,2.21.48,3.14,1.44V6.62ZM64.52,18.97c0-.94-.26-1.71-.79-2.32-.53-.59-1.21-.89-2.05-.89-.79,0-1.46.3-1.99.9-.53.61-.79,1.36-.79,2.26,0,.96.26,1.74.77,2.34.53.61,1.19.91,1.99.91.85,0,1.54-.29,2.07-.88.53-.61.79-1.38.79-2.32ZM76.81,20.24l1.95,1.09c-.3.51-.62.95-.95,1.32s-.69.67-1.08.9c-.38.24-.8.41-1.24.52s-.93.16-1.45.16c-1.49,0-2.69-.48-3.59-1.44-.9-.96-1.35-2.24-1.35-3.83s.44-2.86,1.31-3.83c.88-.96,2.05-1.45,3.51-1.45s2.63.47,3.49,1.4c.85.93,1.27,2.22,1.27,3.87v.54h-7.17c.06.82.33,1.47.8,1.96.47.48,1.08.72,1.81.72.57,0,1.05-.14,1.43-.41.36-.27.78-.78,1.26-1.52ZM71.66,17.61h4.63c-.32-1.23-1.1-1.85-2.33-1.85-.28,0-.54.04-.79.13-.25.09-.47.21-.67.37-.2.16-.37.35-.52.58s-.25.48-.32.77ZM91.43,13.68c-1.24,0-2.22.49-2.94,1.48-.66-.98-1.55-1.48-2.68-1.48-.51,0-.93.09-1.26.26-.31.16-.69.48-1.14.94v-.92h-2.31v9.99h2.31v-5.16c0-1.05.15-1.81.45-2.3.3-.49.77-.73,1.42-.73,1.03,0,1.54.89,1.54,2.67v5.52h2.32v-5.16c0-1.06.15-1.83.44-2.31s.75-.72,1.39-.72c.55,0,.94.2,1.18.6.23.4.35,1.07.35,2.03v5.55h2.32v-6.17c-.02-2.73-1.14-4.09-3.39-4.09ZM109.87,18.54l3.69-4.58h-2.83l-2.27,2.91-2.23-2.91h-2.75l3.59,4.58-4.44,5.4h2.82l3-3.73,2.93,3.73h2.75l-4.26-5.4ZM99.93,8.36c.15.52.13.92.04,1.27-.1.34-.26.62-.48.83-.21.22-.49.38-.83.48-.34.09-.75.11-1.27-.04.15.52.67.93,1.27,1.01.6.1,1.26-.13,1.71-.57.44-.45.67-1.11.57-1.71-.08-.6-.49-1.13-1.01-1.27ZM21.04,18.69l-1.63,3.76h-2.88l-.65,1.5h4.51l1.63-3.76h5.42l-.67-1.5h-5.73ZM99.31,22.44h-2.28v1.5h3.78v-9.99h-1.5v8.49ZM24.57,13.71l-.83-1.86-2.19,5.06h1.63l1.39-3.2ZM23.73,5.53l7.55,16.91h-2.83l.67,1.5h4.47L25.37,5.53h-1.64Z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.28,31.2h54.64c3.26,0,5.9,2.64,5.9,5.89h0c0,3.25-2.64,5.89-5.9,5.89h-54.64c-3.26,0-5.9-2.64-5.9-5.89h0c0-3.25,2.64-5.89,5.9-5.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.18,40.1l1.23-6.3,2.02,4.56,2.09-4.56,1.11,6.3h-.91l-.56-3.55-1.74,3.81-1.69-3.81-.63,3.55h-.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.31,38.68h-2.51l-.65,1.42h-.95l2.9-6.23,2.79,6.23h-.97l-.61-1.42ZM47.96,37.85l-.88-2-.91,2h1.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.93,35.08v5.04h-.88v-5.04h-1.35v-.83h3.58v.83h-1.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.95,36.53h2.53v-2.3h.88v5.86h-.88v-2.74h-2.53v2.74h-.88v-5.86h.88v2.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.99,35.08h-2.35v1.4h2.28v.83h-2.28v1.97h2.35v.83h-3.23v-5.86h3.23v.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.96,40.1l1.23-6.3,2.02,4.56,2.09-4.56,1.11,6.3h-.91l-.56-3.55-1.74,3.81-1.69-3.81-.63,3.55h-.91,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.09,38.68h-2.51l-.65,1.42h-.95l2.9-6.23,2.79,6.23h-.97l-.61-1.42ZM74.72,37.85l-.88-2-.91,2h1.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.69,35.08v5.04h-.88v-5.04h-1.35v-.83h3.58v.83h-1.35,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.71,34.23v5.86h-.88v-5.86h.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.45,34.55v1.05c-.51-.42-1.04-.65-1.58-.65s-1.11.21-1.53.65c-.42.44-.61.97-.61,1.58s.21,1.14.61,1.56.93.63,1.53.63.58-.05.79-.16c.12-.05.25-.12.39-.21s.26-.19.4-.32v1.07c-.51.28-1.04.42-1.6.42-.84,0-1.54-.3-2.14-.88-.6-.6-.88-1.3-.88-2.14s.25-1.4.74-2c.61-.72,1.39-1.07,2.35-1.07s1.04.14,1.53.42v.04Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.89,35.11l-.72.42c-.14-.23-.26-.39-.39-.46-.12-.09-.3-.12-.49-.12s-.46.07-.61.21c-.16.14-.25.32-.25.51s.21.51.63.68l.58.25c.47.19.83.42,1.04.7s.33.61.33,1.02-.18.98-.54,1.33-.81.53-1.35.53-.93-.16-1.26-.46c-.33-.3-.53-.72-.61-1.26l.9-.19c.04.35.11.58.21.72.18.25.46.39.79.39s.51-.09.68-.28.28-.42.28-.7,0-.21-.05-.32-.09-.18-.14-.26-.16-.16-.26-.23-.23-.14-.39-.19l-.56-.23c-.81-.33-1.21-.84-1.21-1.49s.18-.81.51-1.11c.33-.3.75-.46,1.26-.46s1.21.33,1.58.98l.05.02Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademixTextLogoMathematicsBlack);
export default __webpack_public_path__ + "static/media/academix-text-logo-mathematics-black.ced6adf835cd0e3c59c094f78a0cd113.svg";
export { ForwardRef as ReactComponent };